import $ from "jquery";
import { state } from "../settings";
import {
  lastScreenForRemove,
  setAllHotspotsVisibilityScreen,
  showAvailableSpansScreen,
  spansScreen,
} from "./subSystemScreen";
import { raycastItem } from "../raycast";
import {
  lastHeatersForRemove,
  setAllHotspotsVisibility,
  spansHeaters,
} from "./subSystemHeaters";
import { GetGroup } from "../3d-configurator";

export function initSubSystem() {
  spansScreen.forEach((span) => {
    state.currentActiveSpans.forEach((id) => {
      const spanId = $(span.hotspot.element).get(0).id;
      const stateId = id.split("**")[0];

      lastScreenForRemove.last = span;
      raycastItem.push(span);

      span.active = false;

      if (spanId === stateId) {
        if (id.includes("SC")) {
          span.isShades = false;
          span.isScreen = true;

          span.columns.forEach((column) => (column.visible = true));
          span.screens.forEach((screen) => {
            screen.visible = true;

            screen.children.forEach((child) => {
              child.visible = true;
            });
          });
        }

        if (id.includes("SH")) {
          span.isShades = true;
          span.isScreen = false;

          span.shades.forEach((shades) => {
            shades.visible = true;

            shades.children.forEach((child) => {
              child.visible = true;
            });
          });
        }
      }

      return;
    });
  });

  spansHeaters.forEach((span) => {
    state.currentActiveSpans.forEach((id) => {
      const spanId = $(span.hotspot.element).get(0).id;
      if (spanId === id) {
        lastHeatersForRemove.last = span;
        raycastItem.push(span);
        span.isHeater = true;
        span.active = false;
        const index = spanId.split("_");
        const UFO = GetGroup(
          `clone_ufo_${span.side}_${index[index.length - 1]}`
        );

        if (UFO) {
          UFO.visible = true;
          UFO.children.forEach((child) => {
            child.visible = true;
          });
        } else {
          console.log(`UFO group not found: clone_ufo_${span.side}_${index[index.length - 1]}`);
        }
      }
    });
  });

  setAllHotspotsVisibility(false);
  setAllHotspotsVisibilityScreen(false);
}
